import type { ReactNode } from 'react';
import { Box, styled } from '@mui/material';
import type { SxProps } from '@mui/material';
import { titleAndSubTitleClasses } from './titleAndSubTitleClasses';

export type TitleAndSubTitleProps = {
    /**
     * In lack of a better word.
     *
     * The pre-title appears before the title on a small screen, but to the far right of the title on a large screen.
     * It has no styling, and the typical use-case is a link or a button.
     */
    preTitle?: ReactNode;
    title?: ReactNode;
    subTitle?: ReactNode;
    sx?: SxProps;
};

export const Title = styled('h2')(({ theme }) => ({
    fontSize: 26,
    lineHeight: '32px',
    margin: 0,
    padding: 0,
    color: theme.palette.text.primary,
    [theme.breakpoints.up('sm')]: {
        fontSize: 32,
        lineHeight: '36px',
    },
}));

// This is more like an summary than a subtitle
export const SubTitle = styled('p')(({ theme }) => ({
    fontSize: 18,
    lineHeight: '26px',
    margin: 0,
    paddingTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('sm')]: {
        fontSize: 20,
        lineHeight: '28px',
    },
}));

export function TitleAndSubTitle({
    preTitle,
    title,
    subTitle,
    sx,
}: TitleAndSubTitleProps) {
    const titleNode = title ? (
        <Title className={titleAndSubTitleClasses.title}>{title}</Title>
    ) : null;

    return (
        <Box sx={sx}>
            {preTitle ? (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    flexDirection="row-reverse"
                    flexWrap="wrap"
                >
                    {preTitle}
                    {titleNode}
                </Box>
            ) : (
                titleNode
            )}
            <SubTitle className={titleAndSubTitleClasses.subTitle}>
                {subTitle || <span>&nbsp;</span>}
            </SubTitle>
        </Box>
    );
}
